
import alarmQueryDetail from "./components/pi-alarmQuery-detail.vue";
import { Component, Vue } from "vue-property-decorator";
import { getOptionList, optionKey } from "@/api/api-dict";

import {
  getAlarmQuery,
  getSearchInitData,
  getStationByOpr
} from "@/api/api-basic";

import { objAny } from "@/common/common-interface";
import piselectStation from "@/components/select-station/select-station.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
@Component({
  components: {
    "pi-alarmQuery-detail": alarmQueryDetail,
    "pi-select-station": piselectStation,
    "pi-select-oper": piSelectOper
  }
})
export default class AlarmQuery extends Vue {
  // private test: string = "light";
  private alarmQueryDetail: objAny = {};

  private formItem: objAny = {
    modelName: "运营商",
    stationName: "充电站",
    devType: "设备类型",
    alarmLevel: "告警等级",
    eventType: "事件类型",
    alarmTime: "告警时间"
  };
  private loading = false;
  private modelList = [];
  private oprList = [];
  // private deviceTypeList = [];
  private devTypeList: object[] = [];

  private alarmLevelList = [];
  private eventTypeList = [];
  private stationList = [];
  private total = 0;
  private time: object[] = [];

  private formInline: objAny = {
    startTime: "",
    endTime: "",
    searchKey: "",
    type: "",
    field: null,
    oprPkId: "",
    staPkId: "",

    deviceType: "",
    alarmLevel: "",
    alarmType: "",

    curPageFirst: 0,
    globalOrder: "",
    globalglobalPageSize: 10,
    globalSearch: "",
    objectId: "1",

    globalPageIndex: 1,
    globalPageSize: 10,
    totalCount: 19
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: "运营商",
      key: "oprName",
      resizable: true,
      minWidth: 130
    },
    {
      title: "充电站",
      key: "staName",
      resizable: true,
      minWidth: 130
    },
    {
      title: "SN",
      key: "sn",
      resizable: true,
      minWidth: 130
    },
    {
      title: "设备类型",
      key: "deviceTypeName",
      resizable: true,
      minWidth: 90
    },
    {
      title: "告警对象",
      key: "deviceTypeName",
      resizable: true,
      minWidth: 120
    },
    {
      title: "告警类型",
      key: "alarmTypeName",
      resizable: true,
      minWidth: 90
    },
    {
      title: "告警级别",
      key: "alarmLevelName",
      resizable: true,
      minWidth: 90
    },
    {
      title: "告警时间",
      key: "faultTime",
      resizable: true,
      minWidth: 140,
      render: (h: Function, params: objAny) => {
        return h(
          "div",
          this.$common.userDate(
            new Date(params.row.faultTime),
            "yyyy-MM-dd HH:MM:SS"
          )
        );
      }
    },
    {
      title: "事件描述",
      key: "faultDesc",
      resizable: true,
      minWidth: 140
    },
    {
      title: "操作",
      key: "userName",
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  public stationChange(val: number | string) {
    this.formInline.staPkId = val;
  }
  public queryAlarm(): void {
    this.getTableList();
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    // this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public getChild(child: objAny) {
    this.alarmQueryDetail = child;
  }
  public detailBtn(item: objAny, index: number): void {
    this.alarmQueryDetail.open(item, index);
  }
  async getOptionList() {
    const ret = await getOptionList([optionKey.devTypeList]); //请求字典
    this.devTypeList = ret[optionKey.devTypeList]; // 客户名称
  }
  async selectOper(): Promise<void> {
    const ret = await getStationByOpr({ oprPkId: this.formInline.oprPkId });
    if (ret.status === this.$config.apiStatus) {
      this.stationList = ret.data[0].stationList;
    }
  }

  async getTableList(): Promise<void> {
    if (this.formInline.startTime == "" || this.formInline.endTime == "") {
      this.$Message.error("更新时间不能为空 !");
      return;
    }
    this.loading = true;
    const ret = await getAlarmQuery(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async searchInitData(): Promise<void> {
    const ret = await getSearchInitData();
    if (ret.status === this.$config.apiStatus) {
      this.oprList = ret.data[0].oprList;
      // this.deviceTypeList = ret.data[0].deviceTypeList;
      this.alarmLevelList = ret.data[0].alarmLevelList;
      this.eventTypeList = ret.data[0].eventTypeList;
      this.stationList = ret.data[0].stationList;
    }
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      console.log(val[0]);

      this.formInline.startTime =
        this.$common.userDate(val[0]).split(" ")[0] + " 00:00:00";
      console.log(this.formInline.startTime);

      this.formInline.endTime =
        this.$common.userDate(val[1]).split(" ")[0] + " 23:59:59";
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }
  public created(): void {
    const startTime = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    this.formInline.startTime = startTime + "-01 00:00:00";
    this.formInline.endTime = endTime + " 23:59:59";
    this.time = [this.formInline.startTime, this.formInline.endTime];

    this.getOptionList();

    this.getTableList();
    this.searchInitData();
  }
}
